<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="train-filters" [formGroup]="trainForm">
    <div class="power-locos-trains">
        <div class="power-locos-trains-rows">
            <h2>
                <p-radioButton name="trainQueryView" [tabindex]='tabIndex + 1' value="dueOutHour" label="Due Out with No Power" formControlName="trainCheck"
                    (onClick)="disableInput()" labelStyleClass="radio-btn-lable"></p-radioButton>
            </h2>
            <div class="block-view">
                <span class="pull-left">&#60;</span>
                <span class="spinner-container">
        <lms-spinner formControlName="dueOutHourValue"  [tabindex]='tabIndex + 2' [minValue]="0" [maxValue]="99" ngDefaultControl [disabledValue]="!(trainForm.controls.trainCheck.value === 'dueOutHour')"
          [size]="2" [showError]="(trainForm.controls.trainCheck.value === 'dueOutHour')" [inputId]="'dueOutHourValue'">
        </lms-spinner>
        </span>
                <span class="and-text">hrs. </span>
            </div>
        </div>

        <div class="power-locos-trains-rows">
            <h2>
                <p-radioButton name="trainQueryView" [tabindex]='tabIndex + 3' value="noOfLocos" label="Number of Locos" formControlName="trainCheck"
                    (onClick)="disableInput()" labelStyleClass="radio-btn-lable"></p-radioButton>
            </h2>
            <p>
                <p-dropdown [tabindex]='tabIndex + 4' [disabled]="!(trainForm.controls.trainCheck.value === 'noOfLocos')" [options]="noOfLocosList"
                    formControlName="noOfLocosValue"></p-dropdown>
            </p>
        </div>
        <div class="power-locos-trains-rows">
            <h2>
                <p-radioButton name="trainQueryView" [tabindex]='tabIndex + 5' value="hotTrain" label="Hot Trains" formControlName="trainCheck"
                    (onClick)="disableInput()" labelStyleClass="radio-btn-lable"></p-radioButton>
            </h2>
            <p>
                <lms-lms-dropdown [tabindex]='tabIndex + 6' [disabled]="!(trainForm.controls.trainCheck.value === 'hotTrain')" [options]="hotTrainList"
                    formControlName="hotTrainValue" [filter]="true" #hotTrainValueDropDown (onChange)="hotTrainValueDropDown.resetFilter()"></lms-lms-dropdown>
            </p>
        </div>
    </div>
    <div class="power-locos-trains not-moving-gps bdr-right">
        <div class="power-locos-trains-rows">
            <h2>
                <p-radioButton name="trainQueryView" [tabindex]='tabIndex + 8' value="notMovingPerGps" label="Not Moving Per GPS" formControlName="trainCheck"
                    (onClick)="disableInput()" labelStyleClass="radio-btn-lable"></p-radioButton>
            </h2>

            <p>Assigned Units Between </p>
            <p class="block-view">
                <span class="spinner-container">
        <lms-spinner formControlName="minUnit" [tabindex]='tabIndex + 9' [minValue]="0" [maxValue]="99" ngDefaultControl [disabledValue]="!(trainForm.controls.trainCheck.value ==='notMovingPerGps')"
          [size]="2"  [showError]="(trainForm.controls.trainCheck.value === 'notMovingPerGps')" [inputId]="'minUnit'">
        </lms-spinner>
      </span>
                <span class="and-text pull-left"> And </span>
                <span class="spinner-container">
        <lms-spinner formControlName="maxUnit" [tabindex]='tabIndex + 10' [minValue]="0" [maxValue]="99" ngDefaultControl [disabledValue]="!(trainForm.controls.trainCheck.value ==='notMovingPerGps')"
          [size]="2" [showError]="(trainForm.controls.trainCheck.value === 'notMovingPerGps')" [inputId]="'maxUnit'">
        </lms-spinner>
</span>
            </p>
            <p *ngIf="trainForm.controls.trainCheck.value === 'notMovingPerGps' && minMaxError" class="error-bold">Minimum Value is not greater than Maximum value.</p>

        </div>
        <div class="power-locos-trains-rows">
            <p> Number of Hours Between</p>
            <p>
                <span class="spinner-container">
        <lms-spinner formControlName="minGpsHour" [tabindex]='tabIndex + 11' [minValue]="0" [maxValue]="99" ngDefaultControl [disabledValue]="!(trainForm.controls.trainCheck.value ==='notMovingPerGps')"
          [size]="2" [showError]="(trainForm.controls.trainCheck.value === 'notMovingPerGps')" [inputId]="'minGpsHour'">
        </lms-spinner>
</span>

                <span class="and-text pull-left">And </span>
                <lms-spinner formControlName="maxGpsHour" [tabindex]='tabIndex + 12' [minValue]="0" [maxValue]="99" ngDefaultControl [disabledValue]="!(trainForm.controls.trainCheck.value ==='notMovingPerGps')"
                    [size]="2" [showError]="(trainForm.controls.trainCheck.value === 'notMovingPerGps')" [inputId]="'maxGpsHour'">
                </lms-spinner>
            </p>
            <p *ngIf="trainForm.controls.trainCheck.value === 'notMovingPerGps' && minMaxGPSError" class="error-bold">Minimum GPS Hour is not greater than Maximum GPS Hour.</p>
        </div>
        <h2>
            <p-radioButton name="trainQueryView" [tabindex]='tabIndex + 13' value="allTrains" label="All Trains" formControlName="trainCheck"
                (onClick)="disableInput()" labelStyleClass="radio-btn-lable"></p-radioButton>
        </h2>
    </div>
    <div>
        <p-checkbox [disabled]="trainForm.controls.trainCheck.value === 'dueOutHour'" label="Exclude Originating Trains" [binary]="true"
            value="excludeOriginatingTrains" [tabindex]='tabIndex + 14' formControlName="excludeOriginatingTrains"></p-checkbox>
    </div>
</div>